import { client } from 'util/sdk';
import { GET } from 'util/api';
import { ON_HOLD_RULES_CODE } from 'consts';

const returnModel = { name: ON_HOLD_RULES_CODE };

const loadURL = `/${ON_HOLD_RULES_CODE}`;

// eslint-disable-next-line import/prefer-default-export
export const load = () => {
  return client.executeRequest(GET, loadURL, { returnModel });
};
